module.exports = __webpack_public_path__ + "static/media/jmmartinez3.6e5c36e9.jpg";